module.exports = __webpack_public_path__ + "static/img/tu-2.48a102cd.png";